var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-time"},[_c('key-value-unit',{attrs:{"title":"开始时间","value":_vm.reportDetailModel.startTimeStr}}),_c('key-value-unit',{attrs:{"title":"结束时间","value":_vm.reportDetailModel.endTimeStr}}),_c('key-value-unit',{attrs:{"title":"总时间","value":_vm.reportDetailModel.totalSleepTimeStr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }